@if (permDir.uipermission() !== PERMISSIONS.NONE || permDir.editPermissions()) {
  <!--#region Label Top -->

  @if (settings().labelPosition === 'top') {
    <ng-container *ngTemplateOutlet="uiLabelTemplateRef"></ng-container>
  }
  <ng-content select="label[slot-top]"></ng-content>

  <!--#endregion Label Top -->

  <div uiinputcontent (click)="toggleOptionsPopup()">
    <!--#region Default Icon Left -->

    @if (settings().defaultIconSlot === 'left') {
      <ng-container *ngTemplateOutlet="uiDefaultIconTemplateRef"></ng-container>
    }
    <ng-content select="icon[slot-left]"></ng-content>

    <!--#endregion Default Icon Left -->

    <!--#region Label Embedded -->

    @if (settings().labelPosition === 'embedded') {
      <ng-container *ngTemplateOutlet="uiLabelTemplateRef"></ng-container>
    }
    <ng-content select="label[slot-embedded]"></ng-content>

    <!--#endregion Label Embedded -->

    <!--#region Input -->

    <div
      uichipstrip
      readonly
      class="overflow-hidden"
      [class]="inputCssClass()!"
      [ngClass]="{
        'flex-nowrap': settings().shrinkCount,
        'flex-wrap': !settings().shrinkCount,
      }"
      #uiValueRef
      uivalue
      (click)="toggleOptionsPopup(!!settings().optionsAsyncFn)"
    >
      @if (!selectedOption().length && !isTyping()) {
        <span uiplaceholder>{{ this.settings().placeholder }}</span>
      }
      @if (isTyping()) {
        <input
          #uiQueryRef
          type="text"
          [placeholder]="settings().placeholder"
          [class]="inputCssClass()"
          (focusout)="isTyping.set(false)"
          (focusin)="
            settings().clearInputOnFocus ? clearValue($event) : undefined
          "
          (input)="onSearchInputChanged(uiQueryRef.value)"
        />
      } @else {
        @for (
          option of selectedOption().slice(
            0,
            settings().shrinkCount > 0
              ? settings().shrinkCount
              : selectedOption().length
          );
          track $index
        ) {
          <chip
            uiunpermissioned
            [settings]="{
              label: option[this.settings().optionLabel],
              disabled: this.disabled(),
            }"
          >
            <icon
              right
              [iconDefinition]="ICONS.CLOSE"
              (click)="select(option); $event.stopImmediatePropagation()"
            ></icon>
          </chip>
        }
      }
    </div>

    <!--#endregion Input -->

    <!--#region Tools -->

    <div uitoolstrip>
      <ng-container #uiToolsDefaultRef>
        @if (
          settings().showClearButton &&
          selectedValues().length > 0 &&
          !settings().disabled
        ) {
          <btn
            uihovertool
            uicleartool
            uiunpermissioned
            class="unstyled xxs"
            [settings]="{
              icon: ICONS.CLOSE_SMALL,
              iconOnly: true,
            }"
            (click)="clearValue($event); focusout()"
          >
          </btn>
        }
        @if (
          settings().shrinkCount &&
          selectedOption().length > settings().shrinkCount
        ) {
          <btn
            class="unstyled xxs"
            uihovertool
            uiunpermissioned
            [settings]="{
              icon: ICONS.MORE_HORIZ,
              iconOnly: true,
            }"
            [title]="
              'Show ' +
              (selectedOption().length - settings().shrinkCount) +
              ' more'
            "
            (click)="
              toggleMoreOptionsPopup(); $event.stopImmediatePropagation()
            "
          >
          </btn>
        }
      </ng-container>
      <ng-content #uiToolsMarkupRef select="[uitool]"></ng-content>
      <ng-template #uiToolsCodeRef></ng-template>
    </div>

    <!--#endregion Tools -->

    <!--#region Default Icon Right -->

    @if (settings().defaultIconSlot === 'right') {
      <ng-container *ngTemplateOutlet="uiDefaultIconTemplateRef"></ng-container>
    }
    <ng-content select="icon[slot-right]"></ng-content>

    <!--#endregion Default Icon Right -->

    <!--#region Selection Options -->

    <!-- Shrink Rest Popup-->
    @if (permDir.uipermission() !== PERMISSIONS.VIEW) {
      <div
        #uiMoreOptionsToolRef
        uipopupmore
        uichipstrip
        [UiPopup]="popupSettings()"
      >
        @for (
          option of selectedOption().slice(settings().shrinkCount);
          track $index
        ) {
          <chip
            [settings]="{
              label: option[this.settings().optionLabel],
              disabled: this.disabled(),
            }"
          >
            <icon
              right
              [iconDefinition]="ICONS.CLOSE"
              (click)="select(option); $event.stopImmediatePropagation()"
            ></icon>
          </chip>
        }
      </div>

      <!-- Options Popup -->
      <ul
        #uiPopupRef
        [class]="popupCssClass()"
        [UiPopup]="popupSettings()"
        (UiPopupVisibilityChanged)="popupChanged($event)"
      >
        <!-- Search -->
        @if (settings().optionsFiltering) {
          <text
            #uiSearchRef
            uipopupheader
            uiunpermissioned
            [(value)]="filterQuery"
            [settings]="{
              placeholder: 'Start typing to filter',
              placeholderPersists: true,
              tag: settings().label + ' Search',
              stateless: true,
            }"
            (InputChanged)="onFilterInputChanged($event)"
            (click)="$event.stopPropagation()"
          >
            <icon class="pinned" uitool [iconDefinition]="ICONS.FILTER"></icon>
          </text>
        }

        <!-- Select all-->
        @if (settings().allowMultiple && plainOptions().length) {
          <li [attr.uilog]="'Select All'" uipopupoption (click)="selectAll()">
            <check
              uiunpermissioned
              [settings]="{ label: 'Select All', stateless: true }"
              [value]="allValuesAreSelected()"
            >
            </check>
          </li>
        }

        <!-- Options -->
        @for (option of visibleOptions(); track $index) {
          @let prevOptionGroup =
            $index === 0
              ? undefined
              : $safeNavigationMigration(
                  visibleOptions().at($index - 1)?.[settings().optionGroup!]
                );
          @if (
            settings().optionGroup &&
            option[settings().optionGroup!] !== prevOptionGroup
          ) {
            <li uipopupgroup>{{ option[settings().optionGroup!] }}</li>
            <hr />
          }
          <li
            uipopupoption
            [attr.uilog]="option[settings().optionLabel!]"
            [attr.uipopupoptionselected]="
              selectedValues().includes(
                $safeNavigationMigration(option?.[settings().optionValue])
              )
            "
            (click)="select(option); $event.stopImmediatePropagation()"
          >
            @if (UiOptionTemplateRef) {
              <ng-container
                *ngTemplateOutlet="
                  UiOptionTemplateRef;
                  context: { $implicit: option, index: $index, isFirst: $first }
                "
              ></ng-container>
            } @else {
              <check
                uiunpermissioned
                [settings]="{
                  label: $safeNavigationMigration(
                    option?.[settings().optionLabel]
                  ),
                  stateless: true,
                }"
                [value]="
                  selectedValues().includes(
                    $safeNavigationMigration(option?.[settings().optionValue])
                  )
                "
              >
              </check>
            }
          </li>
        } @empty {
          <li UiPopupNonOption>There is no available info to show</li>
        }
      </ul>
    }

    <!--#endregion Selection Options -->
  </div>

  <!--#region Footer -->

  @switch (state()) {
    @case ('error') {
      <span
        uifooter
        uistate="error"
        class="cursor-help"
        [title]="errors().join('\r\n')"
        >{{
          errors().length > 1
            ? errors().at(0) +
              ' (' +
              (errors().length - 1).toString() +
              ' more)'
            : errors().at(0)
        }}</span
      >
    }
    @case ('warning') {
      <span
        uifooter
        uistate="warning"
        class="cursor-help"
        [title]="warnings().join('\r\n')"
        >{{
          warnings().length > 1
            ? warnings().at(0) +
              ' (' +
              (warnings().length - 1).toString() +
              ' more)'
            : warnings().at(0)
        }}</span
      >
    }
    @default {
      @if (
        settings().shrinkCount &&
        selectedOption().length > settings().shrinkCount
      ) {
        <span uifooter>{{
          selectedOption().length - settings().shrinkCount + ' more selected'
        }}</span>
      }
    }
  }

  <!--#endregion Footer -->

  <!--#region Templates -->

  <!-- Label Template -->
  <ng-template #uiLabelTemplateRef>
    <label
      uipopuptrigger
      [class.hidden]="!settings().label && !settings().labelTip"
      [attr.slot-embedded]="
        settings().labelPosition === 'embedded' ? true : undefined
      "
      [label]="labelFormatted()"
      [labelTip]="labelTip()"
      [state]="state()"
    >
    </label>
  </ng-template>

  <!-- Default Icon Template-->
  <ng-template #uiDefaultIconTemplateRef>
    @if (!settings().hideDefaultIcon && !isSearching()) {
      <icon
        [attr.uidefaulticon]="settings().defaultIconSlot"
        [iconDefinition]="defaultIcon()"
        (click)="toggleOptionsPopup()"
      ></icon>
    } @else if (isSearching()) {
      <icon
        class="animate-spin"
        [attr.uidefaulticon]="settings().defaultIconSlot"
        [iconDefinition]="settings().loadingIcon"
      ></icon>
    }
  </ng-template>

  <!-- Modal Template -->
  <ng-template #uiModalsCodeRef></ng-template>

  <!--#endregion Templates -->
}
